module.exports = __webpack_public_path__ + "media/10.4af9c14d.mp3";